import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { TokenInterceptorService } from './shared/services/network/token-interceptor.service';

import * as echarts from 'echarts/core';
import { provideEchartsCore } from 'ngx-echarts';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';
// Import only what you use (recommended)
import { DatePipe } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
// Register required modules
echarts.use([
  BarChart,
  LineChart,
  PieChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  CanvasRenderer,
]);
export const appConfig: ApplicationConfig = {
  providers: [
    provideEchartsCore({ echarts }),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),

    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideAnimations(),
    BsDatepickerModule.forRoot().providers!,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    DatePipe,
  ],
};
